const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

const hexToRgb = (hex) => {
  const normalized = String(hex || "").replace("#", "");
  const safe = normalized.length === 3
    ? normalized.split("").map((char) => `${char}${char}`).join("")
    : normalized;
  const int = Number.parseInt(safe, 16);
  return {
    r: (int >> 16) & 255,
    g: (int >> 8) & 255,
    b: int & 255,
  };
};

const rgbToHex = ({ r, g, b }) =>
  `#${[r, g, b]
    .map((value) => clamp(Math.round(value), 0, 255).toString(16).padStart(2, "0"))
    .join("")}`;

const mix = (from, to, ratio) => {
  const t = clamp(Number.isFinite(ratio) ? ratio : 0, 0, 1);
  const a = hexToRgb(from);
  const b = hexToRgb(to);
  return rgbToHex({
    r: a.r + (b.r - a.r) * t,
    g: a.g + (b.g - a.g) * t,
    b: a.b + (b.b - a.b) * t,
  });
};

export function getParticipantRatingColor(score) {
  if (!Number.isFinite(Number(score))) return "#ffffff";
  const normalized = clamp(Number(score), 0, 100);
  if (normalized <= 50) {
    return mix("#ef4444", "#facc15", normalized / 50);
  }
  return mix("#facc15", "#22c55e", (normalized - 50) / 50);
}

export function getParticipantRatingGradient(score) {
  if (!Number.isFinite(Number(score))) {
    return { start: "#7af5ea", end: "#2dd4bf" };
  }
  const normalized = clamp(Number(score), 0, 100);
  if (normalized <= 25) {
    return { start: "#ff9a8c", end: "#ef4444" };
  }
  if (normalized <= 50) {
    return { start: "#ffe49a", end: "#facc15" };
  }
  if (normalized <= 75) {
    return { start: "#bff58b", end: "#50d27c" };
  }
  return { start: "#7af5ea", end: "#2dd4bf" };
}
